import React from "react";
import { formatDate } from "../../../lib/utils/utils-functions";
import { getPatientName } from "../../utils";
import { PatientNameFormat } from "../../../types/enums";
import { ClientEntityType } from "../../../../../lib/supabase/supabaseTypes";

export const SammelrechnungTableRow: React.FC<{
	row: any;
	index: number;
	showClientNames: boolean;
	showPatientName: boolean;
	showJobTitles: boolean;
	extraSpace: number;
	someRowHasIgnoreMonthlyDiscount: boolean;
	ignoreMonthlyDiscountColumnWidth: number;
	recipient: ClientEntityType;
	keyPrefix?: string;
}> = ({
	row,
	index,
	showClientNames,
	showPatientName,
	showJobTitles,
	extraSpace,
	someRowHasIgnoreMonthlyDiscount,
	ignoreMonthlyDiscountColumnWidth,
	recipient,
	keyPrefix = "",
}) => {
	return (
		<tr key={keyPrefix + row.jobCode + "-" + index}>
			<td
				style={{
					textAlign: "left",
				}}
			>
				{row.jobCode}
			</td>
			<td
				style={{
					textAlign: "left",
				}}
			>
				{formatDate(row.jobDocumentDate)}
			</td>
			{showClientNames && (
				<td
					style={{
						textAlign: "left",
					}}
				>
					{row.clientName}
				</td>
			)}
			{showPatientName && (
				<td
					style={{
						textAlign: "left",
					}}
				>
					{getPatientName(
						row.patientName,
						recipient?.patient_name_format ??
							PatientNameFormat.LAST_NAME_COMMA_FIRST_NAME
					)}
				</td>
			)}
			{showJobTitles && (
				<td
					style={{
						textAlign: "left",
					}}
				>
					{row.jobTitle}
				</td>
			)}
			{extraSpace > 0 && (
				<td
					style={{ width: `${extraSpace}mm` }}
				/>
			)}
			<td
				style={{
					textAlign: "right",
				}}
			>
				{row.jobTotals.total.text}
			</td>
			{someRowHasIgnoreMonthlyDiscount && (
				<td
					style={{
						textAlign: "right",
						width: `${ignoreMonthlyDiscountColumnWidth}%`,
					}}
				>
					{row.ignoreMonthlyDiscount && (
						<span>*</span>
					)}
				</td>
			)}
		</tr>
	);
};